/* @flow */

import { compose } from 'ramda';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import MarketPromptCardDumb from './MarketPromptCardDumb';
import {
  getGuidanceText,
  getGuidanceAction,
} from 'src/shared/app/market/guidance/settings/guidanceSettings';
import {
  setMarketQuery,
  invalidateMarket,
} from 'src/shared/app/market/action/marketActions';
import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';
import { deleteGuidanceMarketPrompt } from 'src/shared/domain/membership/action/membershipActions';
import { getMembership } from 'src/shared/domain/membership/selector/membershipSelectors';
import {
  getMembershipGuidanceSearch,
  getMembershipGuidanceCount,
} from 'src/shared/domain/membership/util/membershipUtil';

import type { State } from 'src/shared/core/type/reduxTypes';
import withRouter from 'src/shared/app/base/component/hoc/withRouter';

import type { NavigateFunction, Location } from 'react-router';

type Props = {
  guidanceLabel: string,
  handleDismiss: (?Object) => void,
  // Self passed
  navigate: NavigateFunction,
  location: Location,
  intl: intlShape,
};

const mapStateToProps = (
  state: State,
  { guidanceLabel, intl, location, navigate }: Props,
): Object => {
  const membership = getMembership(state);

  let topicCount;
  let query;

  if (membership) {
    topicCount = getMembershipGuidanceCount(membership);
    query = getMembershipGuidanceSearch(membership);
  }

  return {
    text: getGuidanceText(guidanceLabel, intl, {
      topicCount,
      query,
    }),
    confirmCta: getGuidanceAction(guidanceLabel, intl, { topicCount }),
    // Used in `mergeProps` only
    membership,
    query,
    navigate,
    location,
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { guidanceLabel, location, navigate }: Props,
): Object => {
  const { membership, query } = stateProps;

  return {
    ...stateProps,
    onClick() {
      trackGAEvent('Market', 'Click prompt', guidanceLabel);

      dispatch(invalidateMarket());
      dispatch(
        deleteGuidanceMarketPrompt(membership, guidanceLabel, {
          search: query,
        }),
      );

      if (query) {
        dispatch(setMarketQuery(query, location, navigate));
      }
    },
    handleDismiss() {
      dispatch(
        deleteGuidanceMarketPrompt(membership, guidanceLabel, {
          search: query,
        }),
      );
    },
  };
};

export default compose(
  injectIntl,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(MarketPromptCardDumb);
